export default class AppFunction{

    static normalizeBasePath(pathname = '') {
        const normalizedPath = `${pathname || ''}`.replace(/\/+$/, '');

        return normalizedPath === '/' ? '' : normalizedPath;
    }

    static resolveConfiguredBaseUrl() {
        const runtimeBaseUrl = window.appBaseUrl || window.localStorage.getItem('base_url') || window.location.origin;

        try {
            return new URL(runtimeBaseUrl, window.location.origin);
        } catch (error) {
            return new URL(window.location.origin);
        }
    }

    static getBaseUrl() {
        const configuredBaseUrl = this.resolveConfiguredBaseUrl();
        const normalizedBaseUrl = `${window.location.origin}${this.normalizeBasePath(configuredBaseUrl.pathname)}`;

        if (window.appBaseUrl !== normalizedBaseUrl) {
            window.appBaseUrl = normalizedBaseUrl;
        }

        if (window.localStorage.getItem('base_url') !== normalizedBaseUrl) {
            window.localStorage.setItem('base_url', normalizedBaseUrl);
        }

        return normalizedBaseUrl;
    }

    static getAppUrl(path) {
        const baseUrl = this.getBaseUrl().replace(/\/+$/, '');
        const normalizedPath = `${path || ''}`.split('/').filter(d => d).join('/');

        return normalizedPath ? `${baseUrl}/${normalizedPath}` : baseUrl;
    }

    static getQueryStringValue(key){
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(key);
    }

    static backToPreviousUrl(){
        history.back();
    }

    static goToNextUrl(){
        history.forward();
    }
}
